import Mainlayout from "../Layouts/Mainlayout";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import Landing from '../pages/Landing'

import {
    createBrowserRouter

} from "react-router-dom";

import {  Errorpage, Contact, Blog, Courses,Faq,SingleBlog} from '../components'
import Singleproduct from "../pages/Singleproduct";
import Products from "../pages/Products";


export const router = createBrowserRouter([
    {
        path: '/',
        element: <Mainlayout/>,
        errorElement: <Errorpage/>,
        children: [
            {
                path: '/',
                element: <Landing/>


            },



            {
                path: '/contact/',
                element: <Contact/>

            },


            {
                path: '/faq/',
                element: <Faq/>

            }
            ,
            {
                path: '/news/',
                element: <Blog/>

            }    ,
            {
                path: '/products',
                element: <Products/>

            }
            ,
            {
                path: '/news/:blogID',
                element: <SingleBlog/>

            }      ,
            {
                path: '/products/:PID',
                element: <Singleproduct/>

            }

            ,
            {
                path: '/courses/',
                element: <Courses/>

            }


        ],


    },

])